var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVramGeneral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "113cm",
    height: "26cm",
    viewBox: "1058 443 2244 519",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1060,
    y: 480,
    width: 280,
    height: 480
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1060,
    y: 480,
    width: 280,
    height: 480
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1340,
    y: 480,
    width: 280,
    height: 480
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1340,
    y: 480,
    width: 280,
    height: 480
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1620,
    y: 480,
    width: 280,
    height: 480
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1620,
    y: 480,
    width: 280,
    height: 480
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 1900,
    y: 480,
    width: 280,
    height: 480
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 1900,
    y: 480,
    width: 280,
    height: 480
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2180,
    y: 480,
    width: 280,
    height: 480
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2180,
    y: 480,
    width: 280,
    height: 480
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2460,
    y: 480,
    width: 280,
    height: 480
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2460,
    y: 480,
    width: 280,
    height: 480
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 2740,
    y: 480,
    width: 280,
    height: 480
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 2740,
    y: 480,
    width: 280,
    height: 480
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 3020,
    y: 480,
    width: 280,
    height: 480
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 3020,
    y: 480,
    width: 280,
    height: 480
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1060,
    y: 469.775
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 1060,
    y: 469.775
  }, "#0000"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1340,
    y: 469.775
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 1340,
    y: 469.775
  }, "#0400"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1620,
    y: 469.775
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 1620,
    y: 469.775
  }, "#0800"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1900,
    y: 469.775
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 1900,
    y: 469.775
  }, "#0C00"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2180,
    y: 469.775
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 2180,
    y: 469.775
  }, "#1000"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2460,
    y: 469.775
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 2460,
    y: 469.775
  }, "#1400"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2740,
    y: 469.775
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 2740,
    y: 469.775
  }, "#1800"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 3020,
    y: 469.775
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 3020,
    y: 469.775
  }, "#1C00"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1200,
    y: 729.775
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 1200,
    y: 729.775
  }, "1Ko"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1480,
    y: 729.775
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 1480,
    y: 729.775
  }, "1Ko"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 1760,
    y: 729.775
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 1760,
    y: 729.775
  }, "1Ko"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2040,
    y: 729.775
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 2040,
    y: 729.775
  }, "1Ko"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2320,
    y: 729.775
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 2320,
    y: 729.775
  }, "1Ko"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2600,
    y: 729.775
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 2600,
    y: 729.775
  }, "1Ko"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 2880,
    y: 729.775
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 2880,
    y: 729.775
  }, "1Ko"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 3160,
    y: 729.775
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 3160,
    y: 729.775
  }, "1Ko"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVramGeneral);
export default __webpack_public_path__ + "static/media/VRAM_General.d060072b078a7447ff8c7bf45ee09fe6.svg";
export { ForwardRef as ReactComponent };